module.exports = __webpack_public_path__ + "img/cloud2_2.088b3013.png";